import { MEDIA_QUERIES } from '../utils/breakpoints.js';

gsap.registerPlugin(ScrollTrigger);

export function initEventsFunctions() {
    (function(){
        let gallary = $(".js-eventGallary");
        if (gallary.length === 0) return;
        let item = gallary.find(".gallary__img");
        if (item.length === 0) return;

        gsap.from(item, {
            left: "50%",
            top: "50%",
            xPercent: -50,
            yPercent: -50,
            rotation: (index) => (index - 2) * -8,
            duration: 1,
            ease: "back.in(1.4)",
            // ease: "elastic.in(1,0.75)",
            scrollTrigger: {
                trigger: gallary,
                start: "top 60%",
                toggleActions: "play none none reverse"
            }
        });
    })();
}